var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#CF499A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 9.35h1.111v-3.3c0-.303.25-.55.556-.55.306 0 .556.247.556.55v3.3a2.21 2.21 0 01-2.223 2.2v4.4a.554.554 0 01-1.111 0v-4.4A2.21 2.21 0 016 9.35v-3.3c0-.303.25-.55.556-.55.305 0 .555.247.555.55v3.3h1.111v-3.3c0-.303.25-.55.556-.55.305 0 .555.247.555.55v3.3zm3.89 1.65V7.7c0-.82.888-1.826 2.088-2.117a.559.559 0 01.69.539v9.828c0 .303-.25.55-.556.55a.554.554 0 01-.556-.55V12.1h-.555a1.109 1.109 0 01-1.111-1.1z",
    fill: "#fff"
  })));
}
export default SvgKafe;